type FullScreenDocumentElement = {
  msRequestFullscreen?: () => void;
  mozRequestFullScreen?: () => void;
  webkitRequestFullscreen?: () => void;
} & HTMLElement;

type FullScreenDocument = {
  documentElement: FullScreenDocumentElement;
  mozFullScreenElement?: Element;
  msFullscreenElement?: Element;
  webkitFullscreenElement?: Element;
  msExitFullscreen?: () => void;
  mozCancelFullScreen?: () => void;
  webkitExitFullscreen?: () => void;
} & Document;

export class FullScreen {
  /* Get the documentElement (<html>) to display the page in fullscreen */
  protected static elem: FullScreenDocumentElement = document.documentElement;
  protected static doc: FullScreenDocument = document;

  public static isOpenFullscreen() {
    return FullScreen.doc.fullscreenElement ||
      FullScreen.doc.webkitFullscreenElement ||
      FullScreen.doc.mozFullScreenElement ||
      FullScreen.doc.msFullscreenElement
      ? true
      : false;
  }

  /* View in fullscreen */
  public static async openFullscreen() {
    if (!FullScreen.isOpenFullscreen()) {
      if (FullScreen.elem.requestFullscreen) {
        await FullScreen.elem.requestFullscreen();
      } else if (FullScreen.elem.webkitRequestFullscreen) {
        /* Safari */
        FullScreen.elem.webkitRequestFullscreen();
      } else if (FullScreen.elem.msRequestFullscreen) {
        /* IE11 */
        FullScreen.elem.msRequestFullscreen();
      }
    }
  }

  /* Close fullscreen */
  public static async closeFullscreen() {
    if (FullScreen.doc.exitFullscreen) {
      await FullScreen.doc.exitFullscreen();
    } else if (FullScreen.doc.webkitExitFullscreen) {
      /* Safari */
      FullScreen.doc.webkitExitFullscreen();
    } else if (FullScreen.doc.msExitFullscreen) {
      /* IE11 */
      FullScreen.doc.msExitFullscreen();
    }
  }

  public static addFullscreenChangeEvent(callback: () => void) {
    FullScreen.doc.addEventListener('fullscreenchange', callback);
    FullScreen.doc.addEventListener('webkitfullscreenchange', callback);
    FullScreen.doc.addEventListener('mozfullscreenchange', callback);
    FullScreen.doc.addEventListener('MSFullscreenChange', callback);
  }
}
